import type { ReactNode } from 'react'

import { BrowserRouter } from 'react-router'

import { NotificationsProvider } from './NotificationsProvider'
import { NuqsProvider } from './NuqsProvider'
import { PlatformProvider } from './PlatformProvider'
import { QueryProvider } from './QueryProvider'
import { SessionProvider } from './SessionProvider'
import { ThemeProvider } from './ThemeProvider'

type AppProvidersProps = {
  children: ReactNode
}

/**
 * Единственное место, где известен полный порядок провайдеров (docs/architecture.md §2.1):
 * платформа → тема → query → роутер → nuqs → сессия → уведомления.
 *
 * BrowserRouter — не через отдельный RouterProvider-компонент, а прямо здесь: маршрут
 * работает в браузере и в TG одинаково (docs/telegram.md §3), history создаётся один раз.
 * NuqsProvider обязан быть ВНУТРИ BrowserRouter — он читает history через хуки роутера.
 */
export function AppProviders(props: AppProvidersProps) {
  const { children } = props

  return (
    <PlatformProvider>
      <ThemeProvider>
        <QueryProvider>
          <BrowserRouter>
            <NuqsProvider>
              <SessionProvider>
                <NotificationsProvider>{children}</NotificationsProvider>
              </SessionProvider>
            </NuqsProvider>
          </BrowserRouter>
        </QueryProvider>
      </ThemeProvider>
    </PlatformProvider>
  )
}
